import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import {
  AUTH_MODULE, DRIVER_TABLE_MODULE,
  LANDING_MODULE,
  MANAGER_MAP_MODULE,
  MAP_PAGE,
  SETTINGS_MODULE, SNACKBAR_MODULE,
  USER_STATISTICS_MODULE
} from './store/modules'

import authModule from './store/modules/auth'
import mapModule from './store/modules/map'
import landingModule from './store/modules/landing'
import settingsModule from './store/modules/settings'
import userStatisticsModule from './store/modules/statistics'
import managerMapModule from './store/modules/manager'
import driverTableModule from './store/modules/driverTable'
import snackbarModule from './store/modules/snackbar'

Vue.use(Vuex)

export default new Vuex.Store({
  mode: 'history',
  plugins: [
    createPersistedState({
      paths: [`${AUTH_MODULE}.auth`, `${AUTH_MODULE}.isSpecial`, SETTINGS_MODULE, USER_STATISTICS_MODULE]
    })
  ],
  modules: {
    [MAP_PAGE]: mapModule,
    [AUTH_MODULE]: authModule,
    [LANDING_MODULE]: landingModule,
    [SETTINGS_MODULE]: settingsModule,
    [USER_STATISTICS_MODULE]: userStatisticsModule,
    [MANAGER_MAP_MODULE]: managerMapModule,
    [DRIVER_TABLE_MODULE]: driverTableModule,
    [SNACKBAR_MODULE]: snackbarModule
  }
})
